export default {
  name: 'KpiPeriodEdit',
  data () {
    return {
      elData: null,
      isLoading: false,
      availablePeriods: null,
      period: null
    }
  },
  methods: {
    loadAvailablePeriods () {
      this.isLoading = true;
      this.ApiRequest.request('kpi/user-company-job-positions/' + this.elData.id + '/periods', this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.availablePeriods = response;
        }
        this.isLoading = false;
      });
    },
    submitForm () {
      this.isLoading = true;
      this.ApiRequest.request('kpi/user-company-job-positions/' + this.elData.id + '/results', this.ApiRequest.REQUEST_POST, { period: this.period }, (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this, { 'item.code': 'general.item.code' });
        } else {
          this.$emit('saved', response.data);
          this.close();
        }
        this.isLoading = false;
      });
    },
    show (elData) {
      this.elData = elData;
      if (!this.elData.user_kpi_data) {
        this.elData.user_kpi_data = { salary: null, kpi_bonus_rate: null, period_type: null };
      }
      this.$refs['modal-window'].show();
    },
    close (elData) {
      this.elData = null; // to trigger elData watcher and load available periods when modal is opened again
      this.$refs['modal-window'].hide();
    }
  },
  computed: {
    periodTypes () {
      const periodTypes = this.$store.getters.getConfigOptions('period_types', this.$i18n.locale);
      periodTypes.forEach(periodType => {
        periodType.text = this.$t('general.period_types.' + periodType.value);
      });
      return periodTypes;
    },
    canEdit () {
      return !this.isLoading;
    }
  },
  watch: {
    elData: {
      immediate: true,
      handler (val) {
        if (val && val.id) {
          this.loadAvailablePeriods();
        }
      }
    }
  },
  mounted () {
  }
}
